// extracted by mini-css-extract-plugin
export var active = "_m1-2";
export var recordingDot = "_m1-1";
export var recordingIndicator = "_m1-0";